<template>
  <div class="top">
    <div class="left">
      <div class="select-appl">
        <RexSearchSelect
          id="select-search-sm-service"
          :data="getAllSMServices()"
          :current="getCurrentSMService()"
          :objectValueIndex="1"
          width="14.875rem"
          @onChoose="onAppChange"
          :searchPlaceholder="searchApp"
          :heading="selectApp"
          :boldActive="boldActive"
        />
      </div>
    </div>
    <!-- to be disable in staging and production -->
    <div class="right">
      <RexButton
        @onClick="astaaRedirect"
        variant="primary"
        :styling="stylingCreateTest"
        id="btn-create-test"
      >
        <BaseIcon
          name="createTest"
          height="1rem"
          width="1rem"
          class="createTest"
        />
        {{ $t('sm.createSyntheticMonitor') }}
      </RexButton>
    </div>
  </div>
</template>

<script>
import RexSearchSelect from '@/rex-components/RexSearchSelect.vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import { AuthService } from '@/services/api/auth.service';
import RexButton from '@/rex-components/rex-button.vue';
import { notificationError } from '@/utils/notification';
import BaseIcon from '@/rex-components/BaseIcon.vue';
import { permissionTypes } from '@/router/constant';
export default {
  components: {
    RexSearchSelect,
    RexButton,
    BaseIcon,
  },
  data() {
    return {
      stylingCreateTest: {
        height: '2.5rem',
        width: '18rem',
      },
      boldActive: true,
      searchApp: this.$t('searchApplication'),
      selectApp: this.$t('selectApplication'),
    };
  },
  computed: {
    ...mapState('globalState/user', ['teamID', 'email']),
  },
  methods: {
    astaaRedirect() {
      try {
        if (
          this.teamID &&
          this.email &&
          this.getCurrentSMService() &&
          this.getCurrentSMService().label
        ) {
          AuthService.atssaLogin(
            this.email,
            this.getCurrentSMService().label,
            this.teamID,
          ).then((resp) => {
            if (
              resp.data != null &&
              resp.data.data != null &&
              resp.data.data.success === true
            ) {
              window.open(resp.data.data.redirect_url, '_blank');
            } else {
              if (resp.data == [] || resp.data == '') {
                notificationError(this.$t('astaaUserError'));
              } else {
                notificationError(this.$t('astaaLoginError'));
              }
            }
          });
        }
      } catch (error) {
        console.log('resp.error', error);
        notificationError(this.$t('astaaLoginError'));
      }
    },
    ...mapActions('syntheticState/commonState', [
      'GET_SYNTHETIC_SERVICES',
      'SELECT_SYNTHETIC_SERVICE',
    ]),
    ...mapGetters('syntheticState/commonState', [
      'getAllSyntheticServices',
      'getCurrentSyntheticServices',
    ]),
    ...mapGetters('globalState/settings', ['getDurationTime']),
    getCurrentSMService() {
      return this.getCurrentSyntheticServices();
    },
    getAllSMServices() {
      return this.getAllSyntheticServices();
    },
    async onAppChange(option) {
      await this.SELECT_SYNTHETIC_SERVICE(option);
    },
    async loadSyntheticService() {
      // console.log(this.getDurationTime())
      try {
        await this.GET_SYNTHETIC_SERVICES({
          duration: this.getDurationTime(),
          serviceReq: { capability: 'S' },
          permissions: [permissionTypes.READ, permissionTypes.WRITE],
        });
      } catch (error) {
        console.log('error', error);
      }
    },
  },
  async mounted() {
    await this.loadSyntheticService();
  },
};
</script>

<style lang="scss" scoped>
.left {
  display: flex;
}
.select-appl {
  text-align: left;
  width: 28rem;
}
.select-os {
  text-align: left;
  margin-left: 1.4rem;
  width: 19rem;
}
.select-version {
  text-align: left;
  margin-left: 1.3rem;
}
.make-default {
  @include flex-center;
  margin-left: 1rem;
  color: $font-primary;
}
.pin-btn {
  border: none;
  background: none;
  @include svg-fill-pointer($color-brand-accent);
}
.top {
  display: flex;
}
.right {
  margin-left: auto;
}
.createTest {
  margin-right: 0.2rem;
}
</style>
